module.exports = __webpack_public_path__ + "static/media/list.3ca6959c.svg";